// Its own file so the standalone TV player (src/tvPlayer) can use it without
// pulling in React components.
const formatScreenshotTime = (iso: string) =>
  new Date(iso).toLocaleString(undefined, {
    weekday: 'short',
    hour: 'numeric',
    minute: '2-digit',
  });

export default formatScreenshotTime;
